import { render, staticRenderFns } from "./SimulationsIndexView.vue?vue&type=template&id=507a5df0&"
import script from "./SimulationsIndexView.vue?vue&type=script&lang=js&"
export * from "./SimulationsIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports